export interface Holiday {
  name: string;
  isRed: boolean; // 빨간날 여부
}

// 고정 공휴일 (MM-DD)
const FIXED: Record<string, Holiday> = {
  '01-01': { name: '신정',       isRed: true },
  '03-01': { name: '삼일절',     isRed: true },
  '05-05': { name: '어린이날',   isRed: true },
  '06-06': { name: '현충일',     isRed: true },
  '08-15': { name: '광복절',     isRed: true },
  '10-03': { name: '개천절',     isRed: true },
  '10-09': { name: '한글날',     isRed: true },
  '12-25': { name: '크리스마스', isRed: true },
};

// 음력 기반 공휴일 (YYYY-MM-DD)
const LUNAR: Record<string, Holiday> = {
  // 2025
  '2025-01-28': { name: '설 연휴', isRed: true },
  '2025-01-29': { name: '설날',   isRed: true },
  '2025-01-30': { name: '설 연휴', isRed: true },
  '2025-05-05': { name: '부처님오신날', isRed: true },
  '2025-10-05': { name: '추석 연휴', isRed: true },
  '2025-10-06': { name: '추석',   isRed: true },
  '2025-10-07': { name: '추석 연휴', isRed: true },
  // 2026
  '2026-02-16': { name: '설 연휴', isRed: true },
  '2026-02-17': { name: '설날',   isRed: true },
  '2026-02-18': { name: '설 연휴', isRed: true },
  '2026-05-24': { name: '부처님오신날', isRed: true },
  '2026-09-24': { name: '추석 연휴', isRed: true },
  '2026-09-25': { name: '추석',   isRed: true },
  '2026-09-26': { name: '추석 연휴', isRed: true },
  // 2027
  '2027-02-06': { name: '설 연휴', isRed: true },
  '2027-02-07': { name: '설날',   isRed: true },
  '2027-02-08': { name: '설 연휴', isRed: true },
  '2027-05-13': { name: '부처님오신날', isRed: true },
  '2027-09-14': { name: '추석 연휴', isRed: true },
  '2027-09-15': { name: '추석',   isRed: true },
  '2027-09-16': { name: '추석 연휴', isRed: true },
};

export function getHoliday(dateStr: string): Holiday | null {
  if (LUNAR[dateStr]) return LUNAR[dateStr];
  const mmdd = dateStr.slice(5);
  if (FIXED[mmdd]) return FIXED[mmdd];
  return null;
}
